import Language from './app/Language.enum'
import localeEn from './locales/app.en.json'
import localeFr from './locales/app.fr.json'

const ONE_MINUTE_SEC = 60
const THIRTY_MINUTES_SEC = 30 * ONE_MINUTE_SEC

const ONE_DAY_SEC = 60 * 60 * 24

const TWO_DAYS = 2
const ONE_YEAR_DAYS = 365

const configByEnv = <T>(configs: Record<string, T>, defaultValue?: T) => {
  return configs[env] ?? (defaultValue as T)
}

const nodeEnv = process.env.NODE_ENV ?? 'production'
const defaultAppEnv = nodeEnv === 'production' ? 'production' : 'local'
const env = process.env.REACT_APP_ENV ?? defaultAppEnv
const hostname = window?.location?.hostname ?? 'localhost'
const isProduction = env === 'production'
const isProductionOrStaging = ['production', 'staging'].includes(env)
const isLocal = !isProductionOrStaging
const isMovingWaldoDomain = /movingwaldo\.com$/.test(hostname)

const config = {
  env,
  isLocal,
  isProduction,
  app: {
    url: configByEnv({
      production: 'https://booking.movingwaldo.com',
      staging: 'https://staging.booking.movingwaldo.com',
    }, 'http://localhost:3000'),
  },
  api: {
    url: configByEnv({
      production: 'https://ib-api.movingwaldo.com',
      staging: 'https://staging.ib-api.movingwaldo.com',
    }, 'http://localhost:4000'),
    includeCredentials: true,
  },
  i18n: {
    locales: {
      en: { app: localeEn },
      fr: { app: localeFr },
    },
    defaultLanguage: 'en',
    defaultNs: 'app',
  },
  cookieyes: {
    enabled: isMovingWaldoDomain && !isLocal,
  },
  monitoring: {
    recordScreenRate: 10.0,
    recordScreenRateError: 100,
  },
  newRelic: {
    licenseKey: 'NRJS-b77793230625f4d2d74',
    accountId: '3447401',
    applicationId: configByEnv({
      production: '1386250861',
      staging: '1386250859',
    }, null),
  },
  analytics: {
    debug: !isProduction,
  },
  facebook: {
    pixelId: '491519291039914',
  },
  reddit: {
    pixelId: 'a2_gw53lpbnmt6b',
  },
  googleAnalytics: {
    measurementId: isProductionOrStaging ? 'G-2GGKNFZRE3' : undefined,
    linkerDomains: ['movingwaldo.com', 'booking.movingwaldo.com'],
  },
  googleMaps: {
    apiKey: configByEnv({
      production: 'AIzaSyAVOmq45bDsyhD-stloqUD5hBM4R-Z13Ng',
      staging: 'AIzaSyDWY0XsOihc4yqu5mWrKQQcEPq3GjMimnY',
    }, 'AIzaSyDrLnXrjU2qaAdvMDP5EfWGrZ5jAti6lCM'),
  },
  calendly: {
    requestMovingQuote: {
      url: {
        [Language.Fr]: 'https://calendly.com/agents-de-reservation/calendrier',
        [Language.En]: 'https://calendly.com/booking-agents/calendar',
      },
    },
    freeConsultation: {
      url: {
        [Language.Fr]: 'https://calendly.com/agents-de-reservation',
        [Language.En]: 'https://calendly.com/booking-agents',
      },
    },
  },
  stripe: {
    publishableKey: configByEnv({
      production: 'pk_live_516uXtdLRfIAkvcPxGhe5VtsRlHkwVsS9eFETJh1vKvX9dVIETaPesvvka3nBepvUGynOxFMVbhY1GtzNzg496IMc000miIIg7M',
    }, 'pk_test_CAn21vTxgmR9NTWMSZcRTAXJ'),
  },
  instantBooking: {
    quote: {
      minDateDays: TWO_DAYS,
      maxDateDays: ONE_YEAR_DAYS,
      quoteMaxAge: ONE_DAY_SEC - THIRTY_MINUTES_SEC,
    },
    notes: {
      maxAttachments: 10,
      imageMaxSize: 1500,
    },
  },
  abTesting: {
    // experimentName: 'steps-identification',
    // nbVariants: 2,
  },
}

export default config
